import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { userScopeCleared } from '@krp/client-runtime'

/**
 * Намерение списка «Кассиры» (RP-CU3): что набрано в поиске и показывать ли архивных. Выбранный кассир здесь не хранится — карточку открывает
 * модальное окно по адресу (`?w=receipts.people.card:<id>`). Кассиры, коды и ответы службы сюда не попадают — они в кэше запросов или нигде.
 */
export interface OwnCashiersIntent { search: string; showArchived: boolean }
export function decodeOwnCashiersIntent(raw: unknown): Partial<OwnCashiersIntent> | undefined {
  if (typeof raw !== 'object' || raw === null) return undefined
  const value = raw as Record<string, unknown>
  return { ...(typeof value.search === 'string' ? { search: value.search } : {}), ...(typeof value.showArchived === 'boolean' ? { showArchived: value.showArchived } : {}) }
}
const initialState: OwnCashiersIntent = { search: '', showArchived: false }
const slice = createSlice({ name: 'ownCashiers', initialState, reducers: {
  ownCashiersPatched: (state, action: PayloadAction<Partial<OwnCashiersIntent>>) => { Object.assign(state, action.payload) },
}, extraReducers: (builder) => {
  builder.addCase(userScopeCleared, () => initialState)
} })
export const { ownCashiersPatched } = slice.actions
export const ownCashiersReducer = slice.reducer
